import React from 'react'
import { useIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
    storeLocatorSearch: {
        defaultMessage: 'Search city, address or  postcode*',
        id: 'store_locator.input.label'
    }
})

export default function useStoreLocator({
    form: {
        control,
        formState: { errors }
    } = {},
    prefix = ''
}) {
    const { formatMessage } = useIntl()
    const fields = {
        "storeLocatorSearch": {
            name: `${prefix}storeLocatorSearch`,
            label: formatMessage(messages.storeLocatorSearch),
            defaultValue: '',
            type: 'text',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Enter a valid city, address or postcode',
                    id: 'store_locator.required.label'
                })
            },
            error: errors[`${prefix}storeLocatorSearch`],
            control,
            placeholder: formatMessage(messages.storeLocatorSearch),
            hideLabel: true
        }
    }

    return fields
}
